<template>
    <div class="position-relative mt-3" id="SubbrancheTable">
      <div class="actions text-right" id="SubbrancheTable-showAddEditDialog">
        <button class="btn btn-primary icon-button" @click="showAddEditDialog = true" id="SubbrancheTable-add-Button">
          <span class="btn-icon" id="SubbrancheTable-addButton-span"><i class="fa fa-plus" aria-hidden="true" id="SubbrancheTable-addButton-data"></i></span>
          {{ 'ADD' | translate }}
        </button>
      </div>

      <vodal :show="showAddEditDialog"
             :width="400"
             :closeOnEsc="true"
             :closeOnClickMask="false"
             :customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto'}"
             animation="rotate"
             @hide="closeDialog">
        <subbranche-add-edit-dialog :edited="editedRow"
                                  ref="addEditDialogue"
                                  :errorMessage="errorMessage"
                                  @save="onSaveNew"
                                  :branche="branche"
                                  @update="onUpdate"
                                  @close="closeDialog"
                                  @clearErrorMessage="clearErrorMessage"
                                  id="SubbrancheTable-addEditDialog"
        ></subbranche-add-edit-dialog>
      </vodal>
      <table class="table table-striped table-hover" id="SubbrancheTable-tableData">
        <caption></caption>
        <tr>
          <th>Code</th>
          <th>Branche</th>
          <th>{{ 'SUBBRANCHE_DESCRIPTION' | translate }}</th>
          <th>Enabled</th>
          <th></th>
        </tr>
        <template v-for="row in rows">
          <tr>
            <td>{{ row.code }}</td>
            <td>{{ getBrancheDescription(row.branche) }}</td>
            <td>{{ row.description }}</td>
            <td>{{ row.enabled }}</td>
            <td id="SubbrancheTable-tableButtons">
              <button class="btn btn-success icon-button icon-button-collapsed"
                  v-tooltip="$options.filters.translate('EDIT')" @click="onEdit(row)" :id="'SubbrancheTable-tableEditButton-'+row.name">
                <span class="btn-icon" :id="'SubbrancheTable-tableEditSpan-'+row.name"><i class="fa fa-pencil" aria-hidden="true" :id="'SubbrancheTable-tableEditData-'+row.name"></i></span>
              </button>
              <button class="btn btn-danger icon-button icon-button-collapsed"
                  v-tooltip="$options.filters.translate('DELETE')" @click="confirmDelete(row)" :id="'SubbrancheTable-tableDeleteButton'+row.name">
                <span class="btn-icon" :id="'SubbrancheTable-tableDeleteSpan-'+row.name"><i class="fa fa-trash-o" aria-hidden="true" :id="'SubbrancheTable-tableDeleteData-'+row.name"></i></span>
              </button>
            </td>
          </tr>
        </template>
      </table>
      <confirm-dialog :show="showDeleteConfirmDialog" :textLabel="'Are you sure you want to delete this?'"
                  @hide-dialog="showDeleteConfirmDialog = false" @confirm="onRemove(selectedRow.id)">
                </confirm-dialog>
    </div>
    </template>

    <script>
    import RestService from '../../../service/RestService.js';
    import SubbrancheAddEditDialog from './SubbrancheAddEditDialog.vue';
    import Datepicker from 'vuejs-datepicker';
    import Vodal from 'vodal';
    import GeneralConfigService from '../../../service/GeneralConfigService';
    import ConfirmDialog from '../../dialog/ConfirmDialog.vue';

    export default {
      components: { SubbrancheAddEditDialog, Datepicker, Vodal, ConfirmDialog },
      data() {
        return {
          rest: this.initRestService(),
          filter: '',
          rows: [],
          newRows: [],
          branche: [],
          editedRow: null,
          showAddEditDialog: false,
          showDeleteConfirmDialog: false,
          selectedRow: null,
          errorMessage: ''
        }
      },
      beforeMount() {
        this.loadRows();
        this.loadBranche();
      },
      methods: {
        initRestService() {
          return new RestService();
        },
        async loadRows() {
          const subbrancheResponse = await this.rest.getAllSubbrancheRows();
          this.rows = subbrancheResponse.data;
        },
        async loadBranche() {
          const brancheResponse = await this.rest.getAllProductlineRows();
          this.branche = brancheResponse.data;
        },
        async onSaveNew(row) {
          try {
            await this.rest.createSubbrancheRow(row);
            this.closeDialog();
            this.loadRows();
          } catch (err) {
            if (err.response.data === 'Duplicate code') {
              this.setErrorMessage(this.$options.filters.translate('DUPLICATE_CODE'));
            }
          }
        },
        async onUpdate(row) {
          await this.rest.updateSubbrancheRow(row);
          this.closeDialog();
          this.loadRows();
        },
        onEdit(row) {
          this.editedRow = { ...row };
          this.showAddEditDialog = true;
        },
        onRemove(rowId) {
          const deletedRow = this.rows.find(row => { return row.id === rowId });
          this.rows = this.rows.filter(row => row.id !== rowId);
          this.rest.deleteSubbrancheRow(rowId);
          GeneralConfigService.removeEnabledSubbranche(deletedRow)
          this.showDeleteConfirmDialog = false;
        },
        closeDialog() {
          if (this.$refs.addEditDialogue) {
            this.$refs.addEditDialogue.clearSubbranche();
          }
          this.showAddEditDialog = false;
          this.editedRow = false;
        },
        setErrorMessage: function (message) {
          this.errorMessage = message;
          setTimeout(() => {
            this.errorMessage = '';
          }, 5000);
        },
        clearErrorMessage() {
          const vm = this;
          vm.setErrorMessage();
        },
        confirmDelete(row) {
          this.selectedRow = row;
          this.showDeleteConfirmDialog = true;
        },
        getBrancheDescription(brancheName) {
          const found = this.branche.find(b => b.name === brancheName || b.code === brancheName);
          return found ? found.description : brancheName;
        }
      }
    }
    </script>

    <style lang="scss" scoped>
      >>> .vue-table {
        border: 0;

        th, td {
          border-right: 0;
          border-bottom: 0;
          border-left: 0;
        }

        thead > tr > th {
          padding-right: .75rem;
          padding-left: 30px !important;
        }

        .arrow:before {
          bottom: 12px;
          right: auto;
          left: 12px;
          font-family: 'FontAwesome', sans-serif;
        }

        .icon-button {
          opacity: 0;
          transition: opacity .1s ease-out;
        }

        tr:hover .icon-button {
          opacity: 1;
        }
      }

      .actions {
        position: absolute;
        z-index: 1;
        top: 10px;
        right: 0;

        .icon-button {
          padding-right: 15px;
          padding-left: 50px;
        }
      }
    </style>



// WEBPACK FOOTER //
// src/components/admin/Subbranche/SubbrancheTable.vue